module.exports = __webpack_public_path__ + "static/media/30OIOS11.8350b30f.jpg";